import { DestroyRef, Injector } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { FormID } from '@finxone-platform/form-action';
import { ButtonActionType, CurrentAccountInfoType } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';

export function assignSpendingBudgetValuesToForm(injector: Injector, formGroup: FormGroup): void {
  const store = injector.get(Store);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const destroyRef = injector.get(DestroyRef);
  // might need to dispatch get Account here
  const account = store.selectSnapshot(AccountState.getCurrentAccount) as CurrentAccountInfoType | undefined;
  const spendingBudget = account?.spendingBudget;

  if (!spendingBudget) return;

  // Disable the save button initially and enable it on form value changes
  ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_SPENDING_BUDGET]: false });
  setTimeout(() => {
    formGroup.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe(() => {
      ctaButtonSignalService.setSignal({ [ButtonActionType.SAVE_SPENDING_BUDGET]: formGroup.valid });
    });
  }, 0);
  formGroup.patchValue(spendingBudget, { emitEvent: false });
  store.dispatch(new UpdateFormDataActionWithId(formGroup.value, FormID.SPENDING_BUDGET_FORM));
}
